import type { MRT_ColumnFiltersState } from "mantine-react-table";
import type { BucketSelection } from "src/components/DocumentGraph/types";
import { buildColumnId } from "../columns/columnHelpers";

interface SeedColumnFiltersParams {
    namespace: string;
    selections: BucketSelection[];
}

export const seedColumnFilters = ({
    namespace,
    selections,
}: SeedColumnFiltersParams): MRT_ColumnFiltersState =>
    selections.map((selection) => ({
        id: buildColumnId(namespace, selection.field),
        value: selection.value,
    }));
